export const kennemerlandFormConfig = {
  // Form metadata
  metadata: {
    title: "Aanmeldformulier Zorg & Veiligheidshuis Kennemerland",
    description: "Vul hier de aanmeldgegevens in",
    defDossier: 2325,
    environment: 255,
    apiUsername: "API_KENNEMERLAND_USERNAME",
    apiKey: "API_KENNEMERLAND_KEY",
    brandColors: {
      primary: "#1abc9c",
      primaryLight: "#48c9b0",
      primaryDark: "#16a085",
      accent: "#f39c12",
      neutral: "#f8f9fa",
      text: "#212529",
      textLight: "#6c757d",
      border: "#e9ecef",
    }
  },

  sections: [
    {
      id: "client-info",
      title: "Gegevens cliënt",
      order: 1,
      layout: {
        columns: { default: 1, md: 2 },
        gap: "gap-6"
      },
      fields: [
        {
          id: "client-name",
          name: "136656",
          type: "text",
          label: "Naam cliënt",
          required: true,
          columnSpan: { default: 1 },
          validation: {
            required: "Dit veld is verplicht"
          }
        },
        {
          id: "birth-date",
          name: "136657",
          type: "date",
          label: "Geboortedatum",
          required: true,
          columnSpan: { default: 1 },
          validation: {
            required: "Dit veld is verplicht"
          }
        },
        {
          id: "address",
          name: "136658",
          type: "text",
          label: "Adres en/of woonplaats",
          required: true,
          columnSpan: { default: 1 },
          validation: {
            required: "Dit veld is verplicht"
          }
        },
        {
          id: "bsn",
          name: "136659",
          type: "text",
          label: "BSN",
          required: false,
          columnSpan: { default: 1 },
          validation: {}
        }
      ]
    },
    {
      id: "submitter-info",
      title: "Gegevens inbrenger",
      order: 2,
      layout: {
        columns: { default: 1, md: 2 },
        gap: "gap-6"
      },
      fields: [
        {
          id: "submitter-name",
          name: "136660",
          type: "text",
          label: "Naam inbrenger",
          required: true,
          columnSpan: { default: 1 },
          validation: {
            required: "Dit veld is verplicht"
          }
        },
        {
          id: "organization",
          name: "136661",
          type: "text",
          label: "Instantie",
          required: true,
          columnSpan: { default: 1 },
          validation: {
            required: "Dit veld is verplicht"
          }
        },
        {
          id: "phone",
          name: "136662",
          type: "phone",
          label: "Telefoonnummer",
          required: false,
          columnSpan: { default: 1 },
          validation: {}
        },
        {
          id: "email",
          name: "136663",
          type: "email",
          label: "Mailadres",
          required: true,
          columnSpan: { default: 1 },
          validation: {
            required: "Dit veld is verplicht",
            pattern: { value: /^\S+@\S+$/i, message: "Ongeldig emailadres" }
          }
        },
        {
          id: "submission-date",
          name: "42805",
          type: "date",
          label: "Datum inbreng",
          required: true,
          columnSpan: { default: 1 },
          validation: {
            required: "Dit veld is verplicht"
          }
        }
      ]
    },
    {
      id: "criteria",
      title: "Criteria Zorg & Veiligheidshuis",
      order: 3,
      layout: {
        columns: { default: 1 },
        gap: "gap-6"
      },
      fields: [
        {
          id: "criteria-check",
          name: "47227",
          type: "checkbox-group",
          label: "Voldoet de casus aan de criteria? (kruis hieronder aan)",
          required: true,
          columnSpan: { default: 1 },
          options: [
            { value: "26844", label: "Problemen op 3 of meer leefgebieden die mogelijk leiden tot crimineel/overlast gevend gedrag" },
            { value: "26845", label: "Verbinding tussen meerdere ketens is nodig om tot een effectieve aanpak te komen" },
            { value: "26846", label: "Reguliere interventies hebben in het verleden herhaaldelijk tot onvoldoende resultaat geleid" }
          ],
          validation: {
            required: "Dit veld is verplicht"
          }
        }
      ]
    },
    {
      id: "content",
      title: "Inhoudelijke toelichting",
      order: 4,
      layout: {
        columns: { default: 1 },
        gap: "gap-6"
      },
      fields: [
        {
          id: "case-description",
          name: "47179",
          type: "textarea",
          label: "Omschrijving van de casus, situatie en/of het probleem",
          required: true,
          columnSpan: { default: 1 },
          validation: {
            required: "Dit veld is verplicht"
          }
        },
        {
          id: "risk-description",
          name: "47226",
          type: "textarea",
          label: "Wat is het veiligheidsrisico / wat zijn de directe risico’s en voor wie?",
          required: true,
          columnSpan: { default: 1 },
          validation: {
            required: "Dit veld is verplicht"
          }
        },
        {
          id: "request-description",
          name: "42795",
          type: "textarea",
          label: "Wat is het doel van de inbreng / wat is uw vraag aan het Zorg & Veiligheidshuis?",
          required: true,
          columnSpan: { default: 1 },
          validation: {
            required: "Dit veld is verplicht"
          }
        }
      ]
    },
    {
      id: "referral-index",
      title: "Verwijsindex (indien cliënt minderjarig is)",
      order: 5,
      layout: {
        columns: { default: 1 },
        gap: "gap-6"
      },
      fields: [
        {
          id: "referral-index-check",
          name: "136666",
          type: "radio-group",
          label: "Is de casus opgenomen in de Verwijsindex? (kruis hieronder aan)",
          required: false,
          columnSpan: { default: 1 },
          options: [
            { value: "60020", label: "Ja" },
            { value: "60021", label: "Nee" },
            { value: "60022", label: "Niet bekend" }
          ],
          validation: {}
        }
      ]
    },
    {
      id: "organizations",
      title: "Welke organisaties / overlegvormen zijn reeds betrokken?",
      order: 6,
      layout: {
        columns: { default: 1 },
        gap: "gap-6"
      },
      fields: [
        {
          id: "client-name-organisatie",
          name: "46943",
          type: "linkSelect",
          label: "organisatie",
          required: true,
          columnSpan: { default: 1 },
          multiSelect: true,
          validation: {
            required: "Dit veld is verplicht"
          },
          apiConfig: {
            credentials: {
              username: "API_KENNEMERLAND_USERNAME",
              password: "API_KENNEMERLAND_KEY"
            },
            requestParams: {
              defDossier: 2322,
              limit: 100
            },
            responseMapping: {
              valueField: "id",  
              labelField: "summary"   
            }
          }

        },

      ]
    },
    {
      id: "client-informed",
      title: "Informeren van de cliënt",
      order: 7,
      layout: {
        columns: { default: 1 },
        gap: "gap-6"
      },
      fields: [
        {
          id: "client-informed-check",
          name: "42818",
          type: "radio-group",
          label: "Hebt u (of evt. een andere ketenpartner) de cliënt reeds geïnformeerd?",
          required: false,
          columnSpan: { default: 1 },
          options: [
            { value: "23506", label: "Ja" },
            { value: "23500", label: "Nee" }
          ],
          validation: {}
        }
      ]
    }
  ],

  // Progress tracking configuration
  progress: {
    enabled: false,
    trackRequiredFields: true
  },

  // Auto-save configuration
  autoSave: {
    enabled: false,
    delay: 1000,
    statusMessages: {
      saving: "Bezig met opslaan...",
      saved: "Automatisch opgeslagen",
      error: "Opslag mislukt"
    }
  },

  // Form submission configuration
  submission: {
    showSummary: true,
    summaryFields: [
      { label: "Voortgang", field: "progress" },
      { label: "Status", field: "status" }
    ],
    submitButton: {
      text: "Aanvraag Versturen",
      disabledText: "Vul alle velden in",
      requireAllRequired: true
    }
  },

  // Base styling configuration
  styling: {
    fonts: {
      primary: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      size: {
        small: "12px",
        base: "14px",
        large: "16px"
      }
    },
    spacing: {
      small: "8px",
      base: "12px",
      medium: "16px",
      large: "24px"
    },
    borderRadius: {
      small: "6px",
      base: "8px",
      large: "12px"
    },
    shadows: {
      small: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
      medium: "0 4px 6px -1px",
      large: "0 8px 15px -3px"
    },
    transitions: {
      fast: "all 0.2s ease-in-out",
      medium: "all 0.3s ease-out"
    },

    // Component-specific styles
    index: {
      width: "20px",
      height: "20px",
      fontSize: "14px"
    },
    title: {
      fontWeight: 400,
      fontSize: "18px"
    },
    label: {
      fontSize: "14px",
      fontWeight: "600",
      lineHeight: "1.4",
      marginTop: "0",
      marginBottom: "8px",
      textAlign: "left",
      letterSpacing: "0.025em",
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
    },
    input: {
      display: "block",
      width: "100%",
      padding: "12px 16px",
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "1.5",
      backgroundColor: "#fff",
      backgroundClip: "padding-box",
      border: "1px solid #c3c3c381",
      height: "48px",
      borderRadius: "8px",
      transition: "all 0.2s ease-in-out",
      boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
    },
    checkbox: {

      width: "auto",
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "1.2",
      border: "none",
      height: "26px",
      borderRadius: "8px",
      transition: "all 0.2s ease-in-out",
      boxShadow: "none",
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
    },
    radio: {

      width: "auto",
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "1.2",
      border: "none",
      height: "26px",
      borderRadius: "8px",
      boxShadow: "none",
    },
    textarea: {
      height: "120px",
      resize: "vertical",
      minHeight: "120px"
    },
    select: {
      control: {
        border: "1px solid #c3c3c381",
        borderRadius: "8px",
        minHeight: "48px",
        boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
      },
      placeholder: {
        color: "#6b7280"
      },
      multiValue: {
        backgroundColor: "#e5e7eb",
        borderRadius: "4px"
      },
      multiValueLabel: {
        color: "#374151",
        fontSize: "14px"
      },
      multiValueRemove: {
        color: "#6b7280",
        ":hover": {
          backgroundColor: "#d1d5db",
          color: "#374151"
        }
      },
      valueContainer: {
        padding: "2px 8px"
      }
    },
    button: {
      background: "linear-gradient(135deg)",
      color: "white",
      fontWeight: "600",
      padding: "12px 24px",
      borderRadius: "8px",
      border: "none",
      fontSize: "14px",
      letterSpacing: "0.025em",
      transition: "all 0.2s ease-in-out",
      boxShadow: "0 4px 6px -1px",
      textTransform: "uppercase"
    }
  }
};

export default kennemerlandFormConfig;